import { getSubdomainUrl, getMainDomainUrl, isSubdomain } from "./subdomain";

/**
 * Blog URL utilities
 * Generates correct URLs for blog navigation across main site and blog subdomain
 */

/**
 * Get the blog home URL
 * From main site: redirects to blog.devdotcom.org
 * From blog subdomain: returns /
 */
export function getBlogHomeUrl(): string {
  if (isSubdomain("blog")) {
    return "/";
  }
  return getSubdomainUrl("blog", "/");
}

/**
 * Get a blog post URL
 * From main site: redirects to blog.devdotcom.org/slug
 * From blog subdomain: returns /slug
 */
export function getBlogPostUrl(slug: string): string {
  if (isSubdomain("blog")) {
    return `/${slug}`;
  }
  return getSubdomainUrl("blog", `/${slug}`);
}

/**
 * Get a blog category URL
 * From main site: redirects to blog.devdotcom.org?category=category
 * From blog subdomain: returns /?category=category
 */
export function getBlogCategoryUrl(category: string): string {
  if (isSubdomain("blog")) {
    return `/?category=${encodeURIComponent(category)}`;
  }
  return getSubdomainUrl("blog", `/?category=${encodeURIComponent(category)}`);
}

/**
 * Get the main site home URL
 * From blog subdomain: redirects to www.devdotcom.org
 * From main site: returns /
 */
export function getMainHomeUrl(): string {
  if (isSubdomain("blog")) {
    return getMainDomainUrl("/");
  }
  return "/";
}

/**
 * Get a main site page URL
 * From blog subdomain: redirects to www.devdotcom.org/path
 * From main site: returns /path
 */
export function getMainPageUrl(path: string): string {
  if (isSubdomain("blog")) {
    return getMainDomainUrl(path);
  }
  return path;
}

/**
 * Check if a URL is external (different subdomain)
 */
export function isExternalBlogUrl(url: string): boolean {
  return url.startsWith("http://") || url.startsWith("https://");
}
